import React from "react";
import WarningIcon from "../atoms/WarningIcon";

const Warning = ({text}) => <div style={{display: 'flex'}}>
    <WarningIcon /> <span style={{marginLeft: '3px'}}>{text}</span>
</div>;

export default Warning;
